import { HttpInterceptorService } from '@/services/http-interceptor.service'
import { Injectable } from '@tanbo/vue-di-plugin';
import { Http } from '@zhfe/common-library';

@Injectable()
export class KoutuEditorHttpService extends HttpInterceptorService {}

export class KantuHttp extends Http {}
